import 'slick-carousel/slick/slick';
import config from '../config';

const { breakpoints } = config;

export default class Slider {
    constructor({ node, ...options }) {
        this.$slider = node;
        this.$sliderContainer = this.$slider.find('.slider__container');
        this.$slides = this.$slider.find('.slider__item');
        this.$sliderCounts = this.$slider.find('.slider__counts');
        this.autoplay = this.$slider.data('autoplay');

        this.options = {
            fade: true,
            infinite: true,
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: this.autoplay || 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: breakpoints.md,
                    settings: {
                        dots: false
                    }
                }
            ],
            ...options
        };
    }

    init() {
        if (this.$sliderContainer.length && this.$slides.length > 1) {
            this.$sliderContainer.slick(this.options);
            this.$sliderCounts.addClass('is-visible');
        }
    }
}




// WEBPACK FOOTER //
// ./components/slider.js